import React from 'react';
import { Typography } from '@mui/material';
import styled from 'styled-components';
import colors from 'theme/colors';

const StyledBox = styled.span`
  display: flex;
  // height: 100vh;
  justify-content: center;
  margin-top: 2rem;
  padding: 4rem 1rem;
  border: dashed 4px ${colors.blueGrey_100};
`;

const ZeroState: React.FC = () => {
  return (
    <StyledBox>
      <Typography variant="body1">Start by adding Worksheet Template Sections</Typography>
    </StyledBox>
  );
};

export default ZeroState;
